import Api from './api';

const BASE = '/app-connectors';

// Helper: normaliza campos lowercase da API para camelCase usado nos componentes
export const normalizeEndpoint = (ep) => ({
  ...ep,
  id: ep.id,
  hirerId: ep.hirerid ?? ep.hirerId,
  appConnectorProviderId: ep.appconnectorproviderid ?? ep.appConnectorProviderId ?? ep.app_connector_provider_id ?? ep.externalproviderid ?? ep.externalProviderId,
  guid: ep.guid,
  name: ep.name,
  description: ep.description,
  endpointUrl: ep.endpointurl ?? ep.endpointUrl,
  providerName: ep.providername ?? ep.providerName,
  providerSlug: ep.providerslug ?? ep.providerSlug,
  isActive: ep.isactive != null ? ep.isactive : ep.isActive,
  isPaused: ep.ispaused != null ? ep.ispaused : ep.isPaused,
  pauseReason: ep.pausereason ?? ep.pauseReason,
  pausedAt: ep.pausedat ?? ep.pausedAt,
  totalEventsReceived: ep.totaleventsreceived ?? ep.totalEventsReceived ?? 0,
  totalEventsProcessed: ep.totaleventsprocessed ?? ep.totalEventsProcessed ?? 0,
  totalEventsFailed: ep.totaleventsfailed ?? ep.totalEventsFailed ?? 0,
  lastEventReceivedAt: ep.lasteventreceivedat ?? ep.lastEventReceivedAt,
  lastEventProcessedAt: ep.lasteventprocessedat ?? ep.lastEventProcessedAt,
  signingSecret: ep.signingsecret ?? ep.signingSecret,
});

export const normalizeProvider = (p) => ({
  ...p,
  id: p.id,
  name: p.name,
  slug: p.slug,
  description: p.description,
  logoUrl: p.logourl ?? p.logoUrl ?? p.logo_url,
  baseUrl: p.baseurl ?? p.baseUrl ?? p.base_url,
  documentationUrl: p.documentationurl ?? p.documentationUrl ?? p.documentation_url,
  authType: p.authtype ?? p.authType ?? p.auth_type ?? '',
  payloadContentType: p.payloadcontenttype ?? p.payloadContentType ?? p.payload_content_type ?? '',
  isActive: p.isactive != null ? p.isactive : (p.isActive != null ? p.isActive : true),
  displayOrder: p.displayorder ?? p.displayOrder ?? p.display_order ?? 0,
  metadata: p.metadata,
});

export const normalizeEvent = (ev) => ({
  ...ev,
  id: ev.id,
  externalEventType: ev.externaleventtype ?? ev.externalEventType ?? ev.external_event_type,
  status: ev.status,
  receivedAt: ev.receivedat ?? ev.receivedAt ?? ev.received_at,
  processedAt: ev.processedat ?? ev.processedAt ?? ev.processed_at,
  processingStartedAt: ev.processingstartedat ?? ev.processingStartedAt ?? ev.processing_started_at,
  errorMessage: ev.errormessage ?? ev.errorMessage ?? ev.error_message,
  retryCount: ev.retrycount ?? ev.retryCount ?? ev.retry_count ?? 0,
  ipAddress: ev.ipaddress ?? ev.ipAddress ?? ev.ip_address,
  rawPayload: ev.rawpayload ?? ev.rawPayload ?? ev.raw_payload,
  enrichedPayload: ev.enrichedpayload ?? ev.enrichedPayload ?? ev.enriched_payload,
  processingResult: ev.processingresult ?? ev.processingResult ?? ev.processing_result,
});

export const normalizeProfile = (p) => ({
  ...p,
  id: p.id,
  name: p.name,
  description: p.description,
  appConnectorEndpointId: p.appconnectorendpointid ?? p.appConnectorEndpointId ?? p.inbound_webhook_endpoint_id,
  appConnectorProviderEventId: p.appconnectorprovidereventid ?? p.appConnectorProviderEventId ?? p.app_connector_provider_event_id ?? p.externalprovidereventid ?? p.externalProviderEventId ?? p.external_provider_event_id,
  eventCode: p.eventcode ?? p.eventCode,
  eventName: p.eventname ?? p.eventName,
  isActive: p.isactive != null ? p.isactive : p.isActive,
  stopOnMappingError: p.stoponmappingerror != null ? p.stoponmappingerror : p.stopOnMappingError,
  ruleCount: p.rulecount ?? p.ruleCount,
  triggerCount: p.triggercount ?? p.triggerCount,
});

export const normalizeProviderEvent = (ev) => ({
  ...ev,
  id: ev.id,
  eventCode: ev.eventcode ?? ev.eventCode ?? ev.event_code,
  eventName: ev.eventname ?? ev.eventName ?? ev.event_name,
  eventDescription: ev.eventdescription ?? ev.eventDescription,
  payloadExample: ev.payloadexample ?? ev.payloadExample ?? ev.payload_example,
  isActive: ev.isactive != null ? ev.isactive : ev.isActive,
  displayOrder: ev.displayorder ?? ev.displayOrder ?? ev.display_order ?? 0,
});

export const normalizeProviderField = (f) => ({
  ...f,
  id: f.id,
  fieldPath: f.fieldpath ?? f.fieldPath ?? f.field_path,
  fieldName: f.fieldname ?? f.fieldName ?? f.field_name,
  fieldDescription: f.fielddescription ?? f.fieldDescription,
  fieldGroup: f.fieldgroup ?? f.fieldGroup ?? f.field_group,
  dataType: f.datatype ?? f.dataType ?? f.data_type ?? 'string',
  exampleValue: f.examplevalue ?? f.exampleValue ?? f.example_value,
  displayOrder: f.displayorder ?? f.displayOrder ?? 0,
});

export const normalizeTemplate = (t) => ({
  ...t,
  id: t.id,
  templateCode: t.templatecode ?? t.templateCode ?? t.template_code,
  templateName: t.templatename ?? t.templateName ?? t.template_name,
  templateDescription: t.templatedescription ?? t.templateDescription ?? t.template_description,
  eventCode: t.eventcode ?? t.eventCode ?? t.event_code,
  displayOrder: t.displayorder ?? t.displayOrder ?? 0,
});

export const normalizeActionType = (at) => ({
  ...at,
  id: at.id,
  category: at.category,
  actionCode: at.actioncode ?? at.actionCode ?? at.action_code,
  actionName: at.actionname ?? at.actionName ?? at.action_name,
  actionDescription: at.actiondescription ?? at.actionDescription,
  displayOrder: at.displayorder ?? at.displayOrder ?? 0,
});

export const normalizeRule = (r) => ({
  ...r,
  id: r.id,
  sourceFieldPath: r.sourcefieldpath ?? r.sourceFieldPath ?? r.source_field_path ?? null,
  targetEntityType: r.targetentitytype ?? r.targetEntityType ?? r.target_entity_type ?? '',
  targetFieldName: r.targetfieldname ?? r.targetFieldName ?? r.target_field_name ?? '',
  transformationType: r.transformationtype ?? r.transformationType ?? r.transformation_type ?? 'DIRECT',
  defaultValue: r.defaultvalue ?? r.defaultValue ?? r.default_value ?? null,
  templateExpression: r.templateexpression ?? r.templateExpression ?? r.template_expression ?? null,
  lookupConfig: r.lookupconfig ?? r.lookupConfig ?? r.lookup_config ?? null,
  referenceConfig: r.referenceconfig ?? r.referenceConfig ?? r.reference_config ?? null,
  isRequired: r.isrequired ?? r.isRequired ?? false,
  displayOrder: r.displayorder ?? r.displayOrder ?? r.display_order ?? 0,
  isActive: r.isactive ?? r.isActive ?? true,
});

export const normalizeTrigger = (t) => ({
  ...t,
  id: t.id,
  appConnectorActionTypeId: t.appconnectoractiontypeid ?? t.appConnectorActionTypeId,
  actionCode: t.actioncode ?? t.actionCode,
  actionName: t.actionname ?? t.actionName,
  category: t.category,
  actionConfig: t.actionconfig ?? t.actionConfig ?? t.action_config,
  executionOrder: t.executionorder ?? t.executionOrder ?? t.execution_order ?? 0,
  conditionConfig: t.conditionconfig ?? t.conditionConfig ?? t.condition_config,
  isActive: t.isactive ?? t.isActive ?? true,
});

const AppConnectorService = {

  // Providers (catálogo global)
  getProviders: () => Api.get(`${BASE}/providers`),
  getProviderById: (id) => Api.get(`${BASE}/providers/${id}`),
  getProviderEvents: (providerId) => Api.get(`${BASE}/providers/${providerId}/events`),
  getProviderEventFields: (providerId, eventId) => Api.get(`${BASE}/providers/${providerId}/events/${eventId}/fields`),
  getProviderTemplates: (providerId) => Api.get(`${BASE}/providers/${providerId}/templates`),

  // Endpoints (CRUD)
  getEndpoints: () => Api.get(`${BASE}/endpoints`),
  getEndpointById: (id) => Api.get(`${BASE}/endpoints/${id}`),
  createEndpoint: (data) => Api.post(`${BASE}/endpoints`, data),
  updateEndpoint: (id, data) => Api.put(`${BASE}/endpoints/${id}`, data),
  deleteEndpoint: (id) => Api.delete(`${BASE}/endpoints/${id}`),
  regenerateSecret: (id) => Api.post(`${BASE}/endpoints/${id}/regenerate-secret`),

  // Events (log)
  getEndpointEvents: (endpointId, params) => Api.get(`${BASE}/endpoints/${endpointId}/events`, { params }),
  getEventById: (endpointId, eventId) => Api.get(`${BASE}/endpoints/${endpointId}/events/${eventId}`),
  replayEvent: (endpointId, eventId) => Api.post(`${BASE}/endpoints/${endpointId}/events/${eventId}/replay`),

  // Entity References
  getEndpointReferences: (endpointId) => Api.get(`${BASE}/endpoints/${endpointId}/references`),

  // Mapping Profiles
  getProfiles: (endpointId) => Api.get(`${BASE}/endpoints/${endpointId}/profiles`),
  getProfileById: (endpointId, profileId) => Api.get(`${BASE}/endpoints/${endpointId}/profiles/${profileId}`),
  createProfile: (endpointId, data) => Api.post(`${BASE}/endpoints/${endpointId}/profiles`, data),
  updateProfile: (endpointId, profileId, data) => Api.put(`${BASE}/endpoints/${endpointId}/profiles/${profileId}`, data),
  deleteProfile: (endpointId, profileId) => Api.delete(`${BASE}/endpoints/${endpointId}/profiles/${profileId}`),
  createProfileFromTemplate: (endpointId, templateCode) => Api.post(`${BASE}/endpoints/${endpointId}/profiles/from-template`, { templateCode }),
  testProfile: (endpointId, profileId, testPayload) => Api.post(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/test`, { testPayload }),

  // Mapping Rules
  getRules: (endpointId, profileId) => Api.get(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules`),
  createRule: (endpointId, profileId, data) => Api.post(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules`, data),
  updateRule: (endpointId, profileId, ruleId, data) => Api.put(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}`, data),
  deleteRule: (endpointId, profileId, ruleId) => Api.delete(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}`),

  // Value Mappings
  getValueMappings: (endpointId, profileId, ruleId) => Api.get(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}/value-mappings`),
  createValueMappings: (endpointId, profileId, ruleId, data) => Api.post(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}/value-mappings`, data),
  updateValueMapping: (endpointId, profileId, ruleId, vmId, data) => Api.put(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}/value-mappings/${vmId}`, data),
  deleteValueMapping: (endpointId, profileId, ruleId, vmId) => Api.delete(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/rules/${ruleId}/value-mappings/${vmId}`),

  // Action Triggers
  getTriggers: (endpointId, profileId) => Api.get(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/triggers`),
  createTrigger: (endpointId, profileId, data) => Api.post(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/triggers`, data),
  updateTrigger: (endpointId, profileId, triggerId, data) => Api.put(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/triggers/${triggerId}`, data),
  deleteTrigger: (endpointId, profileId, triggerId) => Api.delete(`${BASE}/endpoints/${endpointId}/profiles/${profileId}/triggers/${triggerId}`),

  // Action Types (catálogo global)
  getActionTypes: () => Api.get(`${BASE}/action-types`),
  getActionTypeById: (id) => Api.get(`${BASE}/action-types/${id}`),
};

export default AppConnectorService;
